import cn from 'classnames';
import type React from 'react';
import styles from './EntityIcon.module.css';

type Props = {
  icon: React.ReactElement;
  /** Omitted where the badge marks a concept rather than something with a live status. */
  statusDot?: React.ReactElement;
  disabled?: boolean;
  className?: string;
};

export function EntityIcon({ statusDot, icon, disabled, className }: Props) {
  return (
    <div className={cn(styles.EntityIcon, { [styles.EntityIcon___disabled]: disabled }, className)}>
      {statusDot ?
        <div className={styles.EntityIcon_statusDot}>{statusDot}</div>
      : null}
      {icon}
    </div>
  );
}
